<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Loading from "@/components/c-loading";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import popup from "@/components/c-popup";
import i18n from "../../../i18n";
import { scheduleService } from "../../../services/saleservice/schedule.service";
//import GenerateSchedule from "../../../components/generate-schedule.vue";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Property Change Payment Term",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Select,
    Input,
    Button,
    popup
  },
  data() {
    return {
      fetchingStats: false,
      allData: {},
      is_pay_off: false,
      is_principal_down: false,
      is_change_payment: false,
      is_change_date: false,

      not_selected: true,
      changeInfo: {},
      loan_template_id: 0,
      principal_pay: 0,
      loan_template:{},
      newSchedules:{},
      schedule_id:0,
      show_save_btn: false,
      generate_label: i18n.t('general.generate'),
      penalty: 0,
      discount: 0,
      monthly_pay: 0,
      month_amount: 0,
      loan_type_id: 0,
      decimal_calc_type_id: 0,
      interest: 0,
      monthly_pay_loan: 0,
      month_amount_loan: 0,
      show_monthly_pay_loan: false,
      show_month_amount_loan: true,
      show_nothing: true,
      show_changing_info: false,
      show_changing_principal: false,
      show_without_interest: false,
      show_with_interest: false,
      show_action: false,
      type: 0

    };
  },
  mounted() {
    this.loadingData(this.$route.params.id);
  },
  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      scheduleService.changePayment(id)
        .then(response => {
          this.fetchingStats = true;
          this.allData = response.data;
          //this.loan_template['data'] = this.allData.loan_templates;
          console.log(this.allData);
        });
    },
    formatCurrency(value) {

      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

    },
    loanTypeChanged: function(value) {
      let loanType = this.loanTypesList.data.find(item => item.id == value);

      if(loanType == null || loanType == undefined) {
        
        this.payShow = false;
        this.durationShow = false;
      } else {
        this.payShow = loanType.status == 1 ? true : false;
        this.durationShow = loanType.status == 2 ? true : false;
      }
    },
    fn_reset(){
      this.penalty = 0;
      this.discount = 0;
      this.monthly_pay = 0;
      this.month_amount = 0;
      this.principal_pay = 0;
      this.loan_template_id = 0;
      this.schedule_id = 0;
      this.newSchedules = {};
      this.pay_date = "";
      this.laon_date = "";
      this.loan_type_id = 0;
      this.decimal_calc_type_id = 0;
      this.interest = 0;
      this.monthly_pay_loan = 0;
      this.month_amount_loan = 0;
      this.show_monthly_pay_loan = false;
      this.show_month_amount_loan = true;

      this.show_nothing = true;
      this.is_principal_down = false;
      this.is_change_payment = false;
      this.is_pay_off = false;
      this.is_change_date = false;

      this.generate_label = i18n.t('general.generate');
    },
    fn_selecte(id, type){
      this.fetchingStats = false;
      scheduleService.changeInfo(id)
        .then(response => {
          this.fetchingStats = true;
          this.changeInfo = response;
          
          this.fn_reset();

          this.not_selected = false;
          this.schedule_id = id;
          this.newSchedules = {};
          this.pay_date = this.changeInfo.pay_date;
          this.loan_date = this.changeInfo.pay_date;

          this.show_nothing = false;
          this.show_changing_info = true;
          this.show_action = true;

          this.type = type;
          if(type == 1){
            this.is_pay_off = true;
          }else if(type == 2){
            this.is_principal_down = true;
          }else if(type == 3){
            this.is_change_payment = true;
          }else{
            this.is_change_date = true;
          }
        });
    },
    loan_sample(){
      this.pay_date = "1-15-2021";
      this.loan_date = "1-15-2021";
      this.principal_pay=10000;
      this.penalty=100;
      this.discount  = 0;
      this.monthly_pay=500;
      this.month_amount=20;
      this.loan_type_id=1;
      this.decimal_calc_type_id=1;
      this.interest=1;
      this.monthly_pay_loan=1000;
      this.month_amount_loan=20;
    },
    onGenerate(){
      if(this.schedule_id==0){
        alert('Please select schedule first.');
      }else if(this.loan_type_id==0 && this.principal_pay < this.changeInfo.balance && this.type != 1){
        alert('សូមជ្រើសរើស​ប្រភែទកម្ចី');
      }else{
        this.post_generate();
      }

    },
    post_generate(){
      //alert(this.pay_date);
      var obj = {
          schedule_id       : this.schedule_id,
          pay_date          : this.pay_date,
          loan_date         : this.loan_date,
          principal_pay     : this.principal_pay,
          penalty           : this.penalty,
          discount          : this.discount,
          monthly_pay       : this.monthly_pay,
          month_amount      : this.month_amount,
          loan_type_id      :this.loan_type_id,
          decimal_calc_type_id:this.decimal_calc_type_id,
          interest          :this.interest,
          monthly_pay_loan  :this.monthly_pay_loan,
          month_amount_loan :this.month_amount_loan,
          type              :this.type
        };

        console.log(obj);

        scheduleService.generate_change_payment(obj)
          .then(response => {
            this.fetchingStats = true;
            this.newSchedules = response.data;
            this.show_save_btn = true;
            this.generate_label = i18n.t('general.re_generate');
            console.log(this.newSchedules);
          });
        this.$refs['generate-schedule'].show();
    },
    onSave(){
      if(this.newSchedules.length > 0 || this.type == 4){
        var obj = {
          "schedule_id": this.schedule_id,
          "schedules"  : this.newSchedules,
          type         : this.type,
          pay_date     : this.pay_date
        };

        scheduleService.change(obj)
          .then(response => {
            this.fetchingStats = true;
            this.fn_reset();
            this.loadingData(this.$route.params.id);
            console.log(response.data);
          });

      }else{
        alert('Nothing to save');
      }
    },
    change_loan_type(){
      if(this.loan_type_id==2){
        this.show_monthly_pay_loan = true;
        this.show_month_amount_loan = false;
      }else{
        this.show_month_amount_loan = true;
        this.show_monthly_pay_loan = false;
      }
    },

    fn_pay_off(id){
      this.fn_selecte(id, 1);
      this.is_pay_off = true;
    },

    fn_principal_down(id){
      this.fn_selecte(id, 2);
      this.is_principal_down = true;
    },

    fn_change_payment(id){
      this.fn_selecte(id, 3);
      this.is_change_payment = true;
    },
    fn_change_date(id){
      this.fn_selecte(id, 4);
      this.is_change_date = true;
    }

  }
};
</script>

<template>
  <Layout>
    <PageHeader :items="['']" :title="$t('property.change-term') + ' ' + $t('property.text')" />
    <Loading :loaded="fetchingStats" />

    <popup id="generate-schedule" ref="generate-schedule" :title="'Generate Schedule'">
      <table class="content-general schedule-table" width="100%">
        
          <tr class="thead">
            <td><p class="khs">ល.រ</p></td>
            <td><p class="khs">កាលបរិច្ឆេទបង់ប្រាក់</p></td>
            <td><p class="khs">ប្រាក់បង់ប្រចាំខែ</p></td>
            <td><p class="khs">ប្រាក់ដើម</p></td>
            <td><p class="khs">ការប្រាក់</p></td>
            <td><p class="khs">សមតុល្យប្រាក់ដើម</p></td>
          </tr>
       
        <tbody>
          <tr v-for="(list, index) in newSchedules" :key="list.id">
            <td><p class="khs">{{index+1}}</p></td>
            <td><p class="khs">{{`${list.pay_date_show}`}}</p></td>
            <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.integer_pay)}}</p></td>
            <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.principal_pay)}}</p></td>
            <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.interest)}}</p></td>
            <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.balance)}}</p></td>
          </tr>
        </tbody>
      </table>
    </popup> 

    <div class="row">
      <div class="col-sm-8">
        <table class="content-general h6 schedule-table" width="100%">
          
            <tr class="thead">
              <td>{{$t('sale.schedule.no')}}</td>
              <td>{{$t('sale.schedule.date')}}</td>
              <td><p class="khs">ប្រាក់ដើម</p></td>
              <td><p class="khs">ប្រាក់បង់ប្រចាំខែ</p></td>
              <td>{{$t('sale.schedule.principal')}}</td>
              <td>{{$t('sale.schedule.interest')}}</td>
              <td>{{$t('sale.schedule.balance')}}</td>
              <td>{{$t('general.discount')}}</td>
              <td>{{$t('general.status')}}</td>
              <td>{{$t('general.action')}}</td>
            </tr>
          <tbody>
            <tr v-for="(item, index) in allData.schedules" :key="index">
              <td>{{index+1}}</td>
              <td>{{`${item.pay_date_show} (${item.day_show})`}}</td>
              <td>{{formatCurrency(item.principal)}}</td>
              <td>{{formatCurrency(item.integer_pay)}}</td>
              <td>{{formatCurrency(item.principal_pay)}}</td>
              <td>{{formatCurrency(item.interest)}}</td>
              <td>{{formatCurrency(item.balance)}}</td>
              <td>{{formatCurrency(item.discount)}}</td>
              <td><span v-if="item.schedule_status_id == 3" style="font-size: 17pt; line-height: 40%;">&#x2611;</span></td>
              <td>
                <div class="list-inline font-size-20 contact-links mb-0 pagination-rounded">
                  <b-dropdown size="sm"  variant="outline" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" menu-class="dropdown-toggle dropdown-menu-end" class="font-size-20  page-link bg-light pagination-rounded">
                    <template class="page-link bg-light" v-slot:button-content>
                        <i class="bx bx bx-dots-horizontal-rounded" style=" margin-top: 5px"></i>
                    </template>
                    <div class="kh" v-if="item.schedule_status_id == 1">
                        <b-dropdown-item @click="fn_pay_off(item.id)">
                          <i :class="`bx bx-exit font-size-16 align-middle mr-1`"></i>
                            បង់ផ្តាច់
                        </b-dropdown-item>
                        <b-dropdown-item @click="fn_principal_down(item.id)">
                          <i :class="`bx bxs-hourglass-top font-size-16 align-middle mr-1`"></i>
                            រំលួសដើម
                        </b-dropdown-item>
                        <b-dropdown-item @click="fn_change_payment(item.id)">
                          <i :class="`bx bx-transfer-alt font-size-16 align-middle mr-1`"></i>
                            ប្តូរការបង់ប្រាក់
                        </b-dropdown-item>
                        <b-dropdown-item @click="fn_change_date(item.id)">
                          <i :class="`bx bx-transfer-alt font-size-16 align-middle mr-1`"></i>
                            ប្តូរថ្ងៃបង់ប្រាក់
                        </b-dropdown-item>
                    </div>
                  </b-dropdown>
                </div>
              </td>
              <!-- <td>
                <button type="button" class="btn btn-primary" v-if="item.schedule_status_id == 1" @click="fn_selecte(item.id);"><span class="bx bx-transfer-alt"></span></button>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="col-sm-4">
        <div class="card shadow-lg p-3 mb-5 bg-white rounded" v-show="show_nothing">
          <h5 class="card-header khb">{{$t('ms.changing_payment')}}</h5>
          <div class="card-body">
            <h5 class="card-title"><p class="ks">សូមជ្រើសរើសកាវិភាគដែលអ្នកចង់ធ្វើការផ្លាស់ផ្តូរ</p></h5>
          </div>
        </div>
        <div class="card shadow-lg p-3 mb-5 bg-white rounded"  v-show="false">
          <h5 class="card-header khb">{{$t('ms.selected_schedule')}}</h5>
          <div class="card-body">
            <div class="col-md-12">
                <Input 
                  :type="'date'"
                  :id="'pay_date'"
                  :disabled="true"
                  v-model="changeInfo.pay_date"
                  :label="'general.pay_date'"  />
            </div>
            <div class="col-md-12">
                <Input 
                  :type="'number'"
                  :id="'principal'"
                  :disabled="true"
                  v-model="changeInfo.principal"
                  :last="'USD'"
                  :label="'general.balance'"  />
            </div>
            <div class="col-md-12">
                <Input 
                  :type="'number'"
                  :id="'principal_pay'"
                  :disabled="true"
                  v-model="changeInfo.principal_pay"
                  :last="'USD'"
                  :label="'general.principal_pay'"  />
            </div>
            <div class="col-md-12">
                <Input 
                  :type="'number'"
                  :id="'interest_pay'"
                  :disabled="true"
                  v-model="changeInfo.interest"
                  :last="'USD'"
                  :label="'general.interest'"  />
            </div>
            <div class="col-md-12">
                <Input 
                  :type="'number'"
                  :id="'total_pay'"
                  :disabled="true"
                  v-model="changeInfo.total_pay"
                  :last="'USD'"
                  :label="'general.total_pay'"  />
            </div>
          </div>
        </div>
        <div class="card shadow-lg p-3 mb-5 bg-white rounded"  v-show="is_principal_down || is_pay_off || is_change_date">
          <h5 class="card-header khb">{{$t('ms.changing_principal')}}</h5>
          <div class="card-body">
            <div class="col-md-12" v-show="is_pay_off || is_principal_down || is_change_date">
                <Input 
                  :type="'date'"
                  :id="'pay_date'"
                  :disabled="false"
                  v-model="pay_date"
                  :label="'general.pay_date'"  />
            </div>
            <div class="col-md-12" v-show="is_principal_down">
                <Input 
                  :type="'number'"
                  :id="'principal_pay'"
                  :disabled="false"
                  v-model="principal_pay"
                  :last="'USD'"
                  :label="'general.principal_pay'"  />
            </div>
            <div class="col-md-12" v-show="is_pay_off || is_principal_down">
                <Input 
                  :type="'number'"
                  :id="'penalty'"
                  :disabled="false"
                  v-model="penalty"
                  :last="'USD'"
                  :label="'general.penalty'"  />
            </div>
            <div class="col-md-12" v-show="is_pay_off || is_principal_down">
                <Input 
                  :type="'number'"
                  :id="'discount'"
                  :disabled="false"
                  v-model="discount"
                  :last="'USD'"
                  :label="'general.discount'"  />
            </div>
          </div>
        </div>
        <div class="card shadow-lg p-3 mb-5 bg-white rounded" v-show="is_principal_down || is_change_payment">
          <h5 class="card-header khb">{{$t('ms.pay_without_interest')}}</h5>
          <div class="card-body">
            <div class="col-md-12">
                <Input 
                  :type="'date'"
                  :id="'loan_date'"
                  :disabled="false"
                  v-model="loan_date"
                  :label="'general.pay_date'"  />
            </div>
            <div class="col-md-12">
                <Input 
                  :type="'number'"
                  :id="'monthly_pay'"
                  :disabled="false"
                  v-model="monthly_pay"
                  :last="'USD'"
                  :label="'setting.configuration.loan-template.monthly-pay'"  />
            </div>
            <div class="col-md-12">
                <Input 
                  :type="'number'"
                  :id="'month_amount'"
                  :disabled="false"
                  v-model="month_amount"
                  :last="'general.month'"
                  :label="'setting.configuration.loan-template.duration'"  />
            </div>
          </div>
        </div>
        <div class="card shadow-lg p-3 mb-5 bg-white rounded" v-show="is_principal_down || is_change_payment">
          <h5 class="card-header khb">{{$t('ms.pay_with_interest')}}</h5>
          <div class="card-body">
            <div class="col-md-12">
                <Select 
                  :id="'id'"
                  :text="'label'"
                  :required="true"
                  v-model="loan_type_id"
                  @change="change_loan_type();"
                  :list="{data: allData.loan_types}"
                  :label="'setting.configuration.loan-template.type'"  />
            </div>
            <div class="col-md-12">
                <Select 
                  :id="'id'"
                  :text="'label'"
                  :required="true"
                  v-model="decimal_calc_type_id"
                  :list="{data:allData.decimal_calc_types}"
                  :label="'setting.configuration.loan-template.round-role'"  />
            </div>
            <div class="col-md-12">
                <Input 
                  :type="'number'"
                  :id="'rate'"
                  v-model="interest"
                  :last="'general.percentag'"
                  :label="'setting.configuration.loan-template.rate'"  />
            </div>
            <div class="col-md-12" v-show="show_monthly_pay_loan">
                <Input 
                  :type="'number'"
                  :id="'monthly_pay_loan'"
                  v-model="monthly_pay_loan"
                  :last="'general.usd'"
                  :label="'setting.configuration.loan-template.monthly-pay'"  />
            </div>
            <div class="col-md-12" v-show="show_month_amount_loan">
                <Input 
                  :type="'number'"
                  :id="'month_amount_loan'"
                  v-model="month_amount_loan"
                  :last="'general.month'"
                  :label="'setting.configuration.loan-template.duration'"  />
            </div>
          </div>
        </div>
        <div class="card shadow-lg p-3 mb-5 bg-white rounded"  v-show="is_principal_down || is_change_payment || is_pay_off || is_change_date">
          <h5 class="card-header khb">{{$t('general.action')}}</h5>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6" v-show="show_save_btn || is_change_date">
                 <Button v-bind:icon="'bx bx-save'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'success'"
                        @click="onSave()"
                        v-bind:title="$t('general.save')"  />
              </div>
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-certification'" v-show="!is_change_date"
                        v-bind:buttonType="'button'"
                        @click="onGenerate()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="generate_label"  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>